import { CustomerEmployee } from "../customers/customers.model";
import { NotificationForEmployee } from "../../absences/absences.model";

export class Employee {
    id: number;
    isForeignEmployee: boolean;
    name: string;
    surname: string;
    fullName: string;
    email: string;
    phone: string;
    objectTypeId: number;
    code: string;
    isActive: boolean;
    customers: CustomerEmployee[];
    notificationEmployees: NotificationEmployee[];
    emailSignature?: string;
}

export class NotificationEmployee extends NotificationForEmployee {
    employeeId: number;
    constructor(employeeId: number) {
        super();
        this.employeeId = employeeId
    }
}